import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { ITimerService } from '../../../services/timer.service';
import { IAnnotationsStore } from '../annotations.store';
import { IAnnotationUiStore } from '../annotationUi.store';
import { IImageComponentProps } from '../components/Image';
import { IUndoRedoHistory } from '../undoRedoHistory.service';

interface IProps {
  heatmapUrl?: string | null;
  maskUrl?: string | null;
  children: (containerProps: IImageComponentProps) => ReactElement;
}

export const ImageContainer = observer((props: IProps): ReactElement => {
  const annotationUiStore = useInjection(IAnnotationUiStore.$);
  const undoRedoHistory = useInjection(IUndoRedoHistory.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const timer = useInjection(ITimerService.$);

  const { heatmapUrl, maskUrl, children } = props;

  useEffect(() => {
    annotationUiStore.changeIsImageLoading(true);
  }, []);

  const handleZoomLevelChange = (zoom: number): void => {
    if (annotationsStore.image) {
      annotationUiStore.changeZoomLevel(zoom);
    }
  };

  const handleLowResImageLoaded = (): void => {
    setTimeout(() => {
      annotationUiStore.changeIsImageLoading(false);
    }, 0);
    timer.startTimer();
    undoRedoHistory.clearHistory();
  };

  const image = annotationsStore.image;
  const isLoading = annotationUiStore.isImageLoading || (image === undefined && annotationUiStore.isQueueRequestInProgress);

  return (
    <>
      {children({
        isLoading,
        isHighResImageLoading: image !== undefined && image.url === '',
        url: image?.url ?? '',
        lowQualityUrl: image?.lowQualityUrl ?? '',
        height: image?.height ?? 0,
        width: image?.width ?? 0,
        isLeftMenuOpened: annotationUiStore.isLeftMenuOpened,
        zoomLevel: annotationUiStore.zoomLevel,
        minZoomLevel: annotationUiStore.minZoomLevel,
        maxZoomLevel: annotationUiStore.maxZoomLevel,
        onZoomChanged: handleZoomLevelChange,
        onLowResImageLoaded: handleLowResImageLoaded,
        heatmapUrl,
        maskUrl,
      })}
    </>
  );
});
